export const ADD_DATA="ADD_DATA"

export const IS_LOADED="IS_LOADED"